import { Environment } from './@types/environment';
import pkgJSON from '../package.json';

export enum Stage {
  PRO = 'PRO',
  SAND = 'SANDBOX',
  LOCAL = 'LOCAL',
}

export const APP_CONFIG = {
  stage: process.env.NODE_ENV === 'production' ? Stage.PRO : Stage.SAND,
  version: JSON.stringify(pkgJSON.version),
  logLevel: process.env.LOG_LEVEL,
  showAdminPage: process.env.SHOW_ADMIN_PAGE,
  publicUrl: process.env.PUBLIC_URL,
  apiEndpoint: process.env.ENDPOINT_ENV === 'SANDBOX' ? process.env.PROXY_API_ENDPOINT : process.env.API_ENDPOINT,
  entitlementApiUrl:
    process.env.ENDPOINT_ENV === 'SANDBOX' ? process.env.PROXY_ENTITLEMENT_API_URL : process.env.ENTITLEMENT_API_URL,
  baseApiUrl: process.env.ENDPOINT_ENV === 'SANDBOX' ? process.env.PROXY_BASE_API_URL : process.env.BASE_API_URL,
  tenantNetworkApiUrl:
    process.env.ENDPOINT_ENV === 'SANDBOX'
      ? process.env.PROXY_TENANT_NETWORK_API_URL
      : process.env.TENANT_NETWORK_API_URL,
  ssoUrl: process.env.SSO_URL,
  contractOverviewUrl: {
    CHECKOUT: process.env.CHECKOUT_CONTRACT_OVERVIEW_URL,
    MYSCOUT: process.env.MYSCOUT_CONTRACT_OVERVIEW_URL,
  },
  schufaCheckUrl: process.env.SCHUFA_CHECK_URL,
  bonitaetsCheckUrl: process.env.BONITAETS_CHECK_URL,
  checkoutUrl: process.env.CHECKOUT_URL,
  buyingPageUrl: process.env.BUYING_PAGE_URL,
  landingPageUrl: process.env.LANDING_PAGE_URL,
  membershipPageUrl: process.env.MEMBERSHIP_PAGE_URL,
  faqUrl: process.env.FAQ_URL,
  valuationUrl: process.env.VALUATION_URL,
  valuationWizardUrl: process.env.VALUATION_WIZARD_URL,
  mieterEngelURL: process.env.MIETERENGEL_URL,
  mieterEngelLoginURL: process.env.MIETERENGEL_LOGIN_URL,
  wohnenPlusLP: process.env.WOHNENPLUS_LP,
  quickCartUrl: process.env.QUICK_CART_URL,
  financingOfferUrl: process.env.FINANCING_OFFER_URL,
  minekoURL: process.env.MINEKO_URL,
  is24MinekoURL: process.env.IS24_MINEKO_URL,
  relocationUrl: process.env.RELOCATION_URL,
  baseUrl: process.env.BASE_URL,
  dataDogApplicationId: process.env.DATA_DOG_APPLICATION_ID || '',
  dataDogClientToken: process.env.DATA_DOG_CLIENT_TOKEN || '',
  dataDogComponentId: 'Scout24/is24-mein-plus-benefits-frontend',
  dataDogTeam: 'honey-badgers',
  environment: process.env.ENVIRONMENT as Environment,
  trackingBundleBaseUrl: process.env.TRACKING_BUNDLE_BASE_URL as string,
  rentProfileUrl: process.env.RENT_PROFILE_URL,
  magentaTvProductPageUrl: process.env.MAGENTA_TV_PRODUCT_PAGE_URL,
};

export function getConfig() {
  return APP_CONFIG;
}
